export default {
    MEDIA_PICKER_TABS: {
        IMAGES: 1,
        VIDEOS: 2,
        MY_ASSETS: 3
    },
    DEFAULT_STOCK_IMAGE_KEYWORDS: ['wallpaper', 'background', 'backgrounds', 'desktop', 'minimalist', 'bokeh', 'vista', 'scenery', 'atmosphere', 'environment', 'macro', 'aesthetic', 'vibe', 'ethereal', 'overlay', 'homescreen', 'display', 'imagery', 'composition'],
    LOGO_PICKER_ENABLED_TABS: [1, 3],
    IMAGE_ELEMENT_PICKER_ENABLED_TABS: [1, 3],
    IMAGE_PICKER_ENABLED_TABS: [1, 3],
    BACKGROUND_PICKER_ENABLED_TABS: [1, 2, 3],
    RECOMMENDED_IMAGE_SIZES: {
        LOGO: {
            WIDTH: 1080,
            HEIGHT: 1080
        },
        BACKGROUND: {
            WIDTH: 1920,
            HEIGHT: 1080
        }
    },
    LOGO_STOCK_IMAGES_PER_PAGE: 11,
    LOGO_ASSETS_PER_PAGE: 11,
    STOCK_IMAGES_PER_PAGE: 11,
    USER_ASSETS_PER_PAGE: 11,
    BACKGROUND_STOCK_IMAGES_PER_PAGE: 11,
    BACKGROUND_STOCK_VIDEOS_PER_PAGE: 11,
    BACKGROUND_ASSETS_PER_PAGE: 11,
    BACKGROUND_CATALOG_VIDEOS_PER_PAGE: 11,
    STOCK_MEDIA_ORIENTATION: {
        ALL_ORIENTATIONS: "all",
        HORISONTAL: "landscape",
        VERTICAL: "portrait",
        SQUARE: "square"
    },
    IMAGE_CROPPER_CONFIGURATION: {
        LOGO: {
            VIEWPORT_WIDTH: 400,
            VIEWPORT_HEIGHT: 400,
            BOUNDARY_WIDTH: 400,
            BOUNDARY_HEIGHT: 400,
            SHAPE: 'circle'
        },
        BACKGROUND_LANDSCAPE: {
            VIEWPORT_WIDTH: 640,
            VIEWPORT_HEIGHT: 360,
            BOUNDARY_WIDTH: 711,
            BOUNDARY_HEIGHT: 400,
            SHAPE: 'square'
        },
        BACKGROUND_PORTRAIT: {
            VIEWPORT_WIDTH: 225,
            VIEWPORT_HEIGHT: 400,
            BOUNDARY_WIDTH: 295,
            BOUNDARY_HEIGHT: 410,
            SHAPE: 'square'
        },
        BACKGROUND_SQUARE: {
            VIEWPORT_WIDTH: 360,
            VIEWPORT_HEIGHT: 360,
            BOUNDARY_WIDTH: 400,
            BOUNDARY_HEIGHT: 400,
            SHAPE: 'square'
        },
        PARTICLE: {
            VIEWPORT_WIDTH: 256,
            VIEWPORT_HEIGHT: 256,
            BOUNDARY_WIDTH: 300,
            BOUNDARY_HEIGHT: 300,
            SHAPE: 'square',
            ENABLE_RESIZE: false
        },
    },
    LOGO_UPLOAD_MIME_TYPES: 'image/jpeg,image/png',
    IMAGE_ELEMENT_UPLOAD_MIME_TYPES: 'image/jpeg,image/png',
    IMAGE_UPLOAD_MIME_TYPES: 'image/jpeg,image/png',
    BACKGROUND_UPLOAD_MIME_TYPES: 'image/jpeg,image/png,video/mp4',
    BACKGROUND_CATALOG_VIDEOS_NEW_BADGE_TIMEOUT: 'September 3, 2021 12:00:00',
    MAX_UPLOAD_VIDEO_DURATION: 60,
    MAX_UPLOAD_VIDEO_SIZE: 350
}